import { render } from "./btcMinting.vue?vue&type=template&id=36b54775&scoped=true"
import script from "./btcMinting.vue?vue&type=script&lang=js"
export * from "./btcMinting.vue?vue&type=script&lang=js"

import "./btcMinting.vue?vue&type=style&index=0&id=36b54775&scoped=true&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b54775"]])

export default __exports__